import type { Application } from '../../../lib/api'
import { formatLabel } from '../../../lib/format'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function UnderwritingContext({ app }: { app?: Application | null }) {
  return (
    <>
      <SectionHeader color="#f3e8ff">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#6b21a8' }}>Underwriting Review</h3>
      </SectionHeader>
      <SectionBody>
        <dl style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '13px' }}>
          <div>
            <dt style={{ color: '#6b7280', fontWeight: 500 }}>Fiserv Status</dt>
            <dd style={{ color: '#111827', fontSize: '15px', fontWeight: 600 }}>
              {formatLabel(app?.fiserv_status) || 'Submitted'}
            </dd>
          </div>
          <div>
            <dt style={{ color: '#6b7280', fontWeight: 500 }}>Last Polled</dt>
            <dd style={{ color: '#111827' }}>
              {app?.fiserv_submitted_at ? new Date(app.fiserv_submitted_at).toLocaleString() : '—'}
            </dd>
          </div>
        </dl>
        <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '12px' }}>
          Fiserv is polled every 15 minutes. Status updates appear automatically.
        </p>
      </SectionBody>
    </>
  )
}
